import { useQuery } from '@tanstack/react-query';
import getSchoolyears from './getSchoolyears';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';

export const SCHOOLYEARS_WITH_SCHOOLS_AND_CLASSROOMS_KEY =
  'schoolyearsWithSchoolsAndClassrooms';

export default function useSchoolyearsWithSchoolsAndClassrooms() {
  const user = useUser();
  return useQuery({
    queryKey: [SCHOOLYEARS_WITH_SCHOOLS_AND_CLASSROOMS_KEY],
    queryFn: () => getSchoolyears(user.location, true),
    refetchOnWindowFocus: false,
  });
}
